import { render, staticRenderFns } from "./nav-page.vue?vue&type=template&id=2e0e7fe2"
import script from "./nav-page.vue?vue&type=script&lang=js"
export * from "./nav-page.vue?vue&type=script&lang=js"
import style0 from "./nav-page.vue?vue&type=style&index=0&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports